import './loading-spinner.less';
import React from 'react';

const LoadingSpinner = () => <div className="loading-spinner">Loading...</div>;

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/root/components/loading-spinner.js